export default function TableListNoDataRow({
  addPaddingCell = false,
  displayText = 'No Results Found.'
}) {
  return (
    <tr className="table-list-row no-data">
      {addPaddingCell && <td className="table-list-padding-cell" />}
      <td colSpan="100%" className="table-list-cell align-center">
        {displayText}
      </td>
      {addPaddingCell && <td className="table-list-padding-cell" />}
    </tr>
  )
}
